/** CoStar.Api.SuiteResults.ListingResults.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["ApartmentCommunity"] = 1] = "ApartmentCommunity";
    ListingType[ListingType["ApartmentUnitForRent"] = 2] = "ApartmentUnitForRent";
    ListingType[ListingType["SingleFamilyHome"] = 3] = "SingleFamilyHome";
    ListingType[ListingType["ResidentialCommunity"] = 4] = "ResidentialCommunity";
    ListingType[ListingType["TownHome"] = 5] = "TownHome";
    ListingType[ListingType["CondoUnitForRent"] = 6] = "CondoUnitForRent";
    ListingType[ListingType["ResidentialCondoUnitForRent"] = 7] = "ResidentialCondoUnitForRent";
    ListingType[ListingType["Hotel"] = 8] = "Hotel";
    ListingType[ListingType["PropertyForSale"] = 9] = "PropertyForSale";
    ListingType[ListingType["ResidentialPropertyForSale"] = 10] = "ResidentialPropertyForSale";
    ListingType[ListingType["CondoForSale"] = 11] = "CondoForSale";
    ListingType[ListingType["LandForSale"] = 12] = "LandForSale";
    ListingType[ListingType["CommercialPortfolioForSale"] = 13] = "CommercialPortfolioForSale";
    ListingType[ListingType["PropertyDirectSpaceForLease"] = 14] = "PropertyDirectSpaceForLease";
    ListingType[ListingType["ConsolidatedCondoForSale"] = 15] = "ConsolidatedCondoForSale";
    ListingType[ListingType["BuildingParkDirectSpaceLease"] = 16] = "BuildingParkDirectSpaceLease";
    ListingType[ListingType["ShoppingCenterDirectSpaceForLease"] = 17] = "ShoppingCenterDirectSpaceForLease";
    ListingType[ListingType["LandDirectForLease"] = 18] = "LandDirectForLease";
    ListingType[ListingType["CommercialSublease"] = 19] = "CommercialSublease";
    ListingType[ListingType["CommercialLeaseAssignment"] = 20] = "CommercialLeaseAssignment";
    ListingType[ListingType["PropertyCoworking"] = 21] = "PropertyCoworking";
    ListingType[ListingType["PropertyForAuction"] = 22] = "PropertyForAuction";
    ListingType[ListingType["LandForAuction"] = 23] = "LandForAuction";
    ListingType[ListingType["CondoForAuction"] = 24] = "CondoForAuction";
    ListingType[ListingType["PropertyLoanForAuction"] = 25] = "PropertyLoanForAuction";
    ListingType[ListingType["CommercialPortfolioForAuction"] = 26] = "CommercialPortfolioForAuction";
    ListingType[ListingType["DisconnectedForSale"] = 27] = "DisconnectedForSale";
    ListingType[ListingType["DisconnectedSpaceForLease"] = 28] = "DisconnectedSpaceForLease";
})(ListingType || (ListingType = {}));
import { MultipleSourceFields } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.ListingResults.MultipleSourceFields */
export { MultipleSourceFields };
